import { Link } from 'react-router-dom'

export function SavedSearches() {
  return (
    <div className="bg-white rounded-2xl border border-neutral-200 overflow-hidden">
      <div className="p-6 border-b border-neutral-100">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-xl font-semibold text-neutral-900 mb-1">
              Saved Searches
            </h3>
            <p className="text-sm text-neutral-600">
              Get notified when new projects match your criteria
            </p>
          </div>
          <button className="px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-lg hover:bg-primary-700 transition-colors flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            Create Search
          </button>
        </div>
      </div>

      <div className="p-12">
        <div className="max-w-md mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-primary-50 to-primary-100 rounded-2xl flex items-center justify-center">
            <svg className="w-10 h-10 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>

          <h4 className="text-lg font-semibold text-neutral-900 mb-3">
            No saved searches yet
          </h4>

          <p className="text-neutral-600 mb-6 leading-relaxed">
            Create custom searches based on location, price, bedrooms, and more.
            We'll notify you when matching projects become available.
          </p>

          <div className="space-y-3">
            <Link
              to="/projects"
              className="block w-full px-5 py-3 bg-primary-600 text-white rounded-xl hover:bg-primary-700 font-semibold transition-colors"
            >
              Browse Projects
            </Link>

            <button className="w-full px-5 py-3 border-2 border-neutral-200 text-neutral-700 rounded-xl hover:bg-neutral-50 font-medium transition-colors">
              Learn About Saved Searches
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
